import { useCallback } from "react";
import { useNavigate } from "react-router-dom";
import t from "../translations";
import { useProjectLabelMap } from "../hooks/useDatasetViewerSettings";
import { useDatasetDetail } from "./DatasetDetailContext";
import { useDatasetImageFilter } from "./useDatasetImageFilter";
import CropGrid from "./CropGrid";

export default function AllCropsView() {
  const {
    datasetId,
    detailBasePath,
    expandProject,
    loading,
    selectedImage,
    setImageClosed,
  } = useDatasetDetail();
  const { filteredImages, search } = useDatasetImageFilter();
  const projectLabelMap = useProjectLabelMap();
  const navigate = useNavigate();

  // Select source image (URL + expand project); replace to keep history sane.
  const selectImage = useCallback(
    (imageId: number, projectId: number) => {
      setImageClosed(false);
      expandProject(projectId);
      navigate(
        {
          pathname: `${detailBasePath}/${datasetId}/${imageId}`,
          search,
        },
        { replace: true },
      );
    },
    [setImageClosed, expandProject, navigate, detailBasePath, datasetId, search],
  );

  const formatTooltip = useCallback(
    (
      crop: { region: string; imageId: number; projectId: number },
      label: string,
    ) => {
      const project =
        projectLabelMap.get(crop.projectId) ?? t.UnknownProject(crop.projectId);
      return `${project} · ${crop.region.toUpperCase()}${crop.imageId} · ${label}`;
    },
    [projectLabelMap],
  );

  return (
    <CropGrid
      sourceImages={filteredImages}
      testIdPrefix="allCropsView"
      context="dataset"
      sourcesLoading={loading}
      activeImageId={selectedImage?.id}
      onCropClick={selectImage}
      formatTooltip={formatTooltip}
      showSeenBadge
    />
  );
}
